<div class="d-flex justify-content-between align-items-center">
  <h2 mat-dialog-title>
    {{ "SHARED.STORE_FILTER.STORE_TITLE" | translate }}
  </h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <p class="my-1 mb-4">{{ "SHARED.STORE_FILTER.STORE_TEXT" | translate }}</p>
  <form [formGroup]="form">
    <app-text-field
      formFieldName="filterName"
      title="SHARED.STORE_FILTER.INPUT_NAME"
      [showRequiredLabel]="true"
    ></app-text-field>
  </form>
</div>
<div mat-dialog-actions class="flex right gap-3">
  <button mat-raised-button color="white" mat-dialog-close>
    {{ "SHARED.STORE_FILTER.CANCEL" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="onSaveClick()">
    {{ "SHARED.STORE_FILTER.SAVE" | translate }}
  </button>
</div>
